import './logoContainer.scss';
import * as React from 'react';
import useClients from '../../hooks/staticQueries/home/useClients';
import { SectionTitle } from '../layout/sectionTitle';
import { LinkWrapper } from '../linkWrapper';
import { LazyCosmosImage } from '../media/cosmosImage';
export const Logo = ({ client }) => (<LinkWrapper to={client.url} title={client.name}>
    <div className="client-logo">
      <LazyCosmosImage alt={client.name} ticket={client.logo[0].ticket}/>
    </div>
  </LinkWrapper>);
export const LogoContainer = (props) => {
    const { title, className, description } = props;
    const { clients } = useClients();
    return (<div className={`logo-container${className ? ` ${className}` : ''}`}>
      {title && <SectionTitle title={title} description={description}/>}

      {clients.map((client, i) => (<div key={i}>
          <Logo client={client}/>
        </div>))}
    </div>);
};
